import React, { useEffect, useState } from 'react';
import NewUserInfo from '../../Main/NewUserInfo';
import { Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import styles from '../../Main/main.styles';
import axios from 'axios';
import { capitalize, isEmpty } from 'lodash';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import './editProfile.css';
import GirlImage from '../../images/girl.png';
import BoyImage from '../../images/boy.png';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import PersonalInfo from './components/PersonalInfo';
import Security from './components/Security';
import Devices from './components/Devices';
import Subscriptions from './components/Subscriptions';
import Notifications from './components/Notifications';
import Integrations from './components/Integrations';
import Diagnoses from '../CareRecipients/components/Diagnoses';
import Allergies from '../CareRecipients/components/Allergies';
import Instructions from '../CareRecipients/components/Instructions';
import Medicines from '../CareRecipients/components/Medicines';
import Documents from '../CareRecipients/components/Documents';
import HealthInsurance from '../CareRecipients/components/HealthInsurance';
import DoctorContact from '../CareRecipients/components/DoctorContact';
import SideBar from '../../components/SideBar';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()(styles);

const TAB_MENU = [
  'Personal Info',
  'Diagnoses',
  'Allergies',
  'Care Instruction',
  'Medicines',
  'Documents',
  'Health Insurance',
  'Doctor Contact',
  'Security',
  'Integrations',
];

const TabContent = {
  'Personal Info': ({ user }) => <PersonalInfo user={user} />,
  Security: ({ user }) => <Security user={user} />,
  Integrations: ({ user }) => <Integrations user={user} />,
  Diagnoses: ({ user }) => <Diagnoses user={user} />,
  Allergies: ({ user }) => <Allergies user={user} />,
  'Care Instruction': ({ user }) => <Instructions user={user} />,
  Medicines: ({ user }) => <Medicines user={user} />,
  Documents: ({ user }) => <Documents user={user} />,
  'Health Insurance': ({ user }) => <HealthInsurance user={user} />,
  'Doctor Contact': ({ user }) => <DoctorContact user={user} />,
};

const CareRecipientDetailScreen = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const location = useLocation();
  const { classes } = useStyles();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const getTabFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
    return TAB_MENU.includes(tab) ? tab : TAB_MENU[0];
  };

  const [activeTab, setActiveTab] = useState(getTabFromUrl());

  useEffect(() => {
    const tab = getTabFromUrl();
    setActiveTab(tab);
  }, [location.search]);

  const ActiveTabComponent = TabContent[activeTab];

  const TAB_LABEL_KEYS = {
    'Personal Info': 'personalInfo',
    Diagnoses: 'diagnoses',
    Allergies: 'allergies',
    'Care Instruction': 'instructions',
    Medicines: 'medicines',
    Documents: 'documents',
    'Health Insurance': 'healthInsurance',
    'Doctor Contact': 'doctorContact',
    Security: 'security',
    Integrations: 'integrations',
  };

  const handleTabClick = (tab) => {
    history(`/edit-profile?tab=${tab}`);
    setActiveTab(tab);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <div className="flex-column-a" style={{ left: width > 850 ? '15%' : '0%' }}>
            <Grid container className="tab-menu" style={{ flexWrap: isMobile ? 'nowrap' : 'wrap' }}>
              {TAB_MENU.map((item, idx) => (
                <Grid
                  key={idx}
                  className="tab-menu-item"
                  style={{ background: activeTab === item ? '#fff' : 'inherit' }}
                  onClick={() => handleTabClick(item)}
                >
                  {t(TAB_LABEL_KEYS[item] || item)}
                </Grid>
              ))}
            </Grid>

            {ActiveTabComponent && <ActiveTabComponent user={user} />}
          </div>

          <EmergencyButton />
        </div>
      </div>
    </>
  );
};

export default CareRecipientDetailScreen;
